import { createSlice } from "@reduxjs/toolkit";
import { SuccessCriteria } from "../../types/products-module-types";

type SuccessCriteriaListState = {
  actualProductName: string;
  actualProductId: number | null;
  isLoadingDataCriteria: boolean;
  isContentEditable: boolean;
  isProductActive: boolean;
  successCriteriaList: SuccessCriteria[];
  successCriteriaStatuses: [];
  isStatusLoaded: boolean;
  needCriteriaRefresh: boolean;
};

const initialState: SuccessCriteriaListState = {
  actualProductName: "",
  actualProductId: null,
  isLoadingDataCriteria: true,
  isContentEditable: false,
  isProductActive: false,
  successCriteriaList: [],
  successCriteriaStatuses: [],
  isStatusLoaded: false,
  needCriteriaRefresh: false,
};

export const successCriteriaListSlice = createSlice({
  name: "successCriteria",
  initialState,
  reducers: {
    loadSuccessCriteriaListData: (state, action) => {
      state.successCriteriaList = action.payload.successCriteriaList;
      state.actualProductId = action.payload.productId;
      state.needCriteriaRefresh = false;
      state.isLoadingDataCriteria = false;
    },
    loadSuccessCriteriaStatuses: (state, action) => {
      state.successCriteriaStatuses = action.payload;
      state.isStatusLoaded = true;
    },
    setIsLoadingDataCriteria: (state, action) => {
      state.isLoadingDataCriteria = action.payload;
    },
    setActualProductName: (state, action) => {
      state.actualProductName = action.payload;
    },
    setIsContentEditable: (state, action) => {
      state.isContentEditable = action.payload;
    },
    setIsProductActive: (state, action) => {
      state.isProductActive = action.payload;
    },
    setNeedCriteriaRefresh: (state, action) => {
      state.needCriteriaRefresh = action.payload;
    },
    clear: () => initialState,
  },
});

// Action creators are generated for each case reducer function
export const {
  loadSuccessCriteriaListData,
  loadSuccessCriteriaStatuses,
  setIsLoadingDataCriteria,
  setActualProductName,
  setIsContentEditable,
  setIsProductActive,
  setNeedCriteriaRefresh,
  clear,
} = successCriteriaListSlice.actions;

export const IsLoadingDataCriteria = (state: any) => {
  return state.successCriteria.isLoadingDataCriteria;
};

export const SelectNeedCriteriaRefresh = (state: any) => {
  return state.successCriteria.needCriteriaRefresh;
};

export const GetActualProductName = (state: any) => {
  return state.successCriteria.actualProductName;
};

export const GetActualProductId = (state: any) => {
  return state.successCriteria.actualProductId;
};

export const GetIsContentEditable = (state: any) => {
  return state.successCriteria.isContentEditable;
};

export const GetIsProductActive = (state: any) => {
  return state.successCriteria.isProductActive;
};

export const GetSuccessCriteriaList = (state: any) => {
  return state.successCriteria.successCriteriaList;
};

export const SelectSuccessCriteriaStatuses = (state: any) => {
  return state.successCriteria.successCriteriaStatuses;
};

export const SelectIsStatusLoaded = (state: any) => {
  return state.successCriteria.isStatusLoaded;
};

export default successCriteriaListSlice.reducer;
